var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.params.urlSupport)?_c('div',[_c('b-btn',{staticClass:"text-primary support",attrs:{"id":"support","pill":""},on:{"click":_vm.open}},[_c('i',{staticClass:"icon icon-support"})]),_c('b-tooltip',{attrs:{"target":"support","variant":"primary","triggers":"hover"}},[_vm._v(" "+_vm._s(_vm.$t(`main.support.tooltip`))+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }